module.exports = __webpack_public_path__ + "img/asli-logo-giris-02.ad3500d3.png";